export default __webpack_public_path__ + "static/IBMPlexSans-MediumItalic-Cyrillic-c60d76a862e3f7c518a7827ae108013b.woff";